import { render, staticRenderFns } from "./ReferenceFrameViz.vue?vue&type=template&id=6d1a2e1a&scoped=true"
import script from "./ReferenceFrameViz.vue?vue&type=script&lang=js"
export * from "./ReferenceFrameViz.vue?vue&type=script&lang=js"
import style0 from "./ReferenceFrameViz.vue?vue&type=style&index=0&id=6d1a2e1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1a2e1a",
  null
  
)

export default component.exports